// import React, { useMemo, useState } from 'react';
// import PropTypes from 'prop-types';
// import { toast } from 'react-toastify';

// import api from '../../services/api';

// import {
//   Wrapper,
//   Header,
//   Title,
//   Field,
//   FieldLabel,
//   Select,
//   Body,
//   ItemBase,
//   ItemBaseLabel,
//   ItemBaseDesc,
//   ItemBasePn,
//   ListLabel,
//   List,
//   EmptyMessage,
//   ItemRow,
//   Checkbox,
//   ItemInfo,
//   ItemDesc,
//   ItemPn,
//   Footer,
//   CancelButton,
//   ConfirmButton,
// } from './styles';

// /** chave única do item na página */
// const chaveItem = (i) => `${i.idItem}::${i.idMaterial}`;

// function ModalCriarConjunto({ item, itensPagina, onClose, onCriado }) {
//   /** 'unico' (default) | 'todos' */
//   const [replicacao, setReplicacao] = useState('unico');
//   const [selecionados, setSelecionados] = useState({});
//   const [salvando, setSalvando] = useState(false);

//   /** demais itens da página (menos o item aberto) */
//   const outrosItens = useMemo(
//     () =>
//       (itensPagina || []).filter(
//         (i) =>
//           !(
//             String(i.idItem) === String(item.idItem) &&
//             Number(i.idMaterial) === Number(item.idMaterial)
//           )
//       ),
//     [itensPagina, item]
//   );

//   const toggle = (i) => {
//     const chave = chaveItem(i);
//     setSelecionados((prev) => ({ ...prev, [chave]: !prev[chave] }));
//   };

//   const handleConfirmar = async () => {
//     const itens = outrosItens
//       .filter((i) => selecionados[chaveItem(i)])
//       .map((i) => ({ idItem: i.idItem, idMaterial: Number(i.idMaterial) }));

//     if (!itens.length) {
//       toast.warn('Selecione ao menos um item para o conjunto.');
//       return;
//     }

//     setSalvando(true);
//     try {
//       await api.post(
//         `/catalogo-publico/${item.idCatalogo}/pagina/${item.idPagina}/conjunto`,
//         {
//           itemOri: {
//             idItem: item.idItem,
//             idMaterial: Number(item.idMaterial),
//           },
//           itens,
//           replicar: replicacao === 'todos',
//         }
//       );

//       toast.success('Conjunto/kit criado com sucesso.');
//       if (onCriado) onCriado();
//       onClose();
//     } catch (err) {
//       toast.error('Não foi possível criar o conjunto/kit.');
//     } finally {
//       setSalvando(false);
//     }
//   };

//   return (
//     <Wrapper>
//       <Header>
//         <Title>Criar conjunto/kit</Title>

//         <Field>
//           <FieldLabel htmlFor="replicacao-conjunto">
//             Aplicação do conjunto
//           </FieldLabel>
//           <Select
//             id="replicacao-conjunto"
//             value={replicacao}
//             onChange={(e) => setReplicacao(e.target.value)}
//           >
//             <option value="unico">Único (apenas para este item)</option>
//             <option value="todos">
//               Replicar para todos os itens escolhidos
//             </option>
//           </Select>
//         </Field>
//       </Header>

//       <Body>
//         <ItemBase>
//           <ItemBaseLabel>Item base</ItemBaseLabel>
//           <ItemBaseDesc>{item.descricao}</ItemBaseDesc>
//           {item.partnumber ? <ItemBasePn>{item.partnumber}</ItemBasePn> : null}
//         </ItemBase>

//         <ListLabel>Itens do sistema ({outrosItens.length})</ListLabel>

//         <List>
//           {outrosItens.length === 0 && (
//             <EmptyMessage>Não há outros itens neste sistema.</EmptyMessage>
//           )}

//           {outrosItens.map((i) => {
//             const chave = chaveItem(i);
//             return (
//               <ItemRow key={chave}>
//                 <Checkbox
//                   type="checkbox"
//                   checked={!!selecionados[chave]}
//                   onChange={() => toggle(i)}
//                 />
//                 <ItemInfo>
//                   <ItemDesc>{i.descricao}</ItemDesc>
//                   {i.partnumber ? <ItemPn>{i.partnumber}</ItemPn> : null}
//                 </ItemInfo>
//               </ItemRow>
//             );
//           })}
//         </List>
//       </Body>

//       <Footer>
//         <CancelButton type="button" onClick={onClose} disabled={salvando}>
//           Cancelar
//         </CancelButton>
//         <ConfirmButton
//           type="button"
//           onClick={handleConfirmar}
//           disabled={salvando}
//         >
//           {salvando ? 'Salvando...' : 'Confirmar'}
//         </ConfirmButton>
//       </Footer>
//     </Wrapper>
//   );
// }

// ModalCriarConjunto.propTypes = {
//   item: PropTypes.shape({
//     idCatalogo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//     idPagina: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//     idItem: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//     idMaterial: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//     descricao: PropTypes.string,
//     partnumber: PropTypes.string,
//   }).isRequired,
//   itensPagina: PropTypes.arrayOf(PropTypes.object),
//   onClose: PropTypes.func.isRequired,
//   onCriado: PropTypes.func,
// };

// ModalCriarConjunto.defaultProps = {
//   itensPagina: [],
//   onCriado: null,
// };

// export default ModalCriarConjunto;

import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import api from '../../services/api';

import {
  Wrapper,
  Header,
  Title,
  Field,
  FieldLabel,
  Select,
  Body,
  ItemBase,
  ItemBaseLabel,
  ItemBaseDesc,
  ItemBasePn,
  ListLabel,
  List,
  EmptyMessage,
  ItemRow,
  Checkbox,
  ItemInfo,
  ItemDesc,
  ItemPn,
  Footer,
  CancelButton,
  ConfirmButton,
} from './styles';

/** chave única do item na página */
const chaveItem = (i) => `${i.idItem}::${i.idMaterial}`;

function ModalCriarConjunto({ item, itensPagina, onClose, onCriado }) {
  /** 'unico' (default) | 'todos' */
  const [replicacao, setReplicacao] = useState('unico');
  const [selecionados, setSelecionados] = useState({});
  const [salvando, setSalvando] = useState(false);

  /** demais itens da página (menos o item aberto) */
  const outrosItens = useMemo(
    () =>
      (itensPagina || []).filter(
        (i) =>
          !(
            String(i.idItem) === String(item.idItem) &&
            Number(i.idMaterial) === Number(item.idMaterial)
          )
      ),
    [itensPagina, item]
  );

  const toggle = (i) => {
    const chave = chaveItem(i);
    setSelecionados((prev) => ({ ...prev, [chave]: !prev[chave] }));
  };

  const handleConfirmar = async () => {
    const itens = outrosItens
      .filter((i) => selecionados[chaveItem(i)])
      .map((i) => ({ idItem: i.idItem, idMaterial: Number(i.idMaterial) }));

    if (!itens.length) {
      toast.warn('Selecione ao menos um item para o conjunto.');
      return;
    }

    setSalvando(true);
    try {
      await api.post(
        `/catalogo-publico/${item.idCatalogo}/pagina/${item.idPagina}/conjunto`,
        {
          itemOri: {
            idItem: item.idItem,
            idMaterial: Number(item.idMaterial),
          },
          itens,
          replicar: replicacao === 'todos',
        }
      );

      toast.success('Conjunto/kit criado com sucesso.');
      if (onCriado) onCriado();
      onClose();
    } catch (err) {
      toast.error('Não foi possível criar o conjunto/kit.');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Wrapper>
      <Header>
        <Title>Criar conjunto/kit</Title>

        <Field>
          <FieldLabel htmlFor="replicacao-conjunto">
            Aplicação do conjunto
          </FieldLabel>
          <Select
            id="replicacao-conjunto"
            value={replicacao}
            onChange={(e) => setReplicacao(e.target.value)}
          >
            <option value="unico">Único (apenas para este item)</option>
            <option value="todos">
              Replicar para todos os itens escolhidos
            </option>
          </Select>
        </Field>
      </Header>

      <Body>
        <ItemBase>
          <ItemBaseLabel>Item base</ItemBaseLabel>
          <ItemBaseDesc>{item.descricao}</ItemBaseDesc>
          {item.partnumber ? <ItemBasePn>{item.partnumber}</ItemBasePn> : null}
        </ItemBase>

        <ListLabel>Itens do sistema ({outrosItens.length})</ListLabel>

        <List>
          {outrosItens.length === 0 && (
            <EmptyMessage>Não há outros itens neste sistema.</EmptyMessage>
          )}

          {outrosItens.map((i) => {
            const chave = chaveItem(i);
            return (
              <ItemRow key={chave}>
                <Checkbox
                  type="checkbox"
                  checked={!!selecionados[chave]}
                  onChange={() => toggle(i)}
                />
                <ItemInfo>
                  {/* IDITEM antes da descrição para facilitar a localização
                      do item na página durante a montagem do kit */}
                  <ItemDesc>
                    {i.idItem !== undefined && i.idItem !== null
                      ? `${i.idItem} - ${i.descricao || ''}`
                      : i.descricao}
                  </ItemDesc>
                  {i.partnumber ? <ItemPn>{i.partnumber}</ItemPn> : null}
                </ItemInfo>
              </ItemRow>
            );
          })}
        </List>
      </Body>

      <Footer>
        <CancelButton type="button" onClick={onClose} disabled={salvando}>
          Cancelar
        </CancelButton>
        <ConfirmButton
          type="button"
          onClick={handleConfirmar}
          disabled={salvando}
        >
          {salvando ? 'Salvando...' : 'Confirmar'}
        </ConfirmButton>
      </Footer>
    </Wrapper>
  );
}

ModalCriarConjunto.propTypes = {
  item: PropTypes.shape({
    idCatalogo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    idPagina: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    idItem: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    idMaterial: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    descricao: PropTypes.string,
    partnumber: PropTypes.string,
  }).isRequired,
  itensPagina: PropTypes.arrayOf(PropTypes.object),
  onClose: PropTypes.func.isRequired,
  onCriado: PropTypes.func,
};

ModalCriarConjunto.defaultProps = {
  itensPagina: [],
  onCriado: null,
};

export default ModalCriarConjunto;
